var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from "react";
import { MemoPager } from "./PagerFunctional";
import { Footer, FooterStrip } from "..";
import { Button, Divider, Flex } from "@costar/theme-ui";
var PagerWithFooter = function (props) {
    var totalItems = props.totalItems, pageSize = props.pageSize, pageNumber = props.pageNumber, formatNumber = props.formatNumber, setPageNumber = props.setPageNumber, setPageSize = props.setPageSize, pageSizeOptions = props.pageSizeOptions, footerProps = props.footerProps, modifyTable = props.modifyTable, _a = props.disablePagination, disablePagination = _a === void 0 ? false : _a;
    var finalMemoPager = useMemo(function () {
        return pageNumber != null && pageSize != null ? (React.createElement(MemoPager, { selectedPageNumber: pageNumber, selectedPageSize: pageSize, totalItems: totalItems, formatNumber: formatNumber, onPageChange: setPageNumber, onPageSizeChange: setPageSize, showSinglePage: true, pageSizeOptions: pageSizeOptions, view: "listView", disablePagination: disablePagination })) : null;
    }, [
        disablePagination,
        formatNumber,
        pageNumber,
        pageSize,
        pageSizeOptions,
        setPageNumber,
        setPageSize,
        totalItems,
    ]);
    var finalModifyTable = useMemo(function () {
        return (React.createElement(Flex, null,
            React.createElement(Divider, { orientation: "vertical", height: "22px", mt: "xs-2" }),
            React.createElement(Button, { variant: "ghost", disabled: modifyTable === null || modifyTable === void 0 ? void 0 : modifyTable.isDisabled, fontSize: "xxs", mt: "xs-2", onClick: modifyTable === null || modifyTable === void 0 ? void 0 : modifyTable.onModifyTable, textShadow: "none !important", "automation-id": "footer-modify-table" }, modifyTable === null || modifyTable === void 0 ? void 0 : modifyTable.modifyTableLabel)));
    }, [modifyTable === null || modifyTable === void 0 ? void 0 : modifyTable.isDisabled, modifyTable === null || modifyTable === void 0 ? void 0 : modifyTable.modifyTableLabel, modifyTable === null || modifyTable === void 0 ? void 0 : modifyTable.onModifyTable]);
    return (React.createElement(FooterStrip, null,
        React.createElement(Footer, __assign({}, footerProps)),
        !(footerProps === null || footerProps === void 0 ? void 0 : footerProps.noPager) ? finalMemoPager : null,
        modifyTable ? finalModifyTable : null));
};
export { PagerWithFooter };
//# sourceMappingURL=PagerWithFooter.js.map